<app-header></app-header>
<div class="app-body">
  <router-outlet></router-outlet>
  <app-aside></app-aside>
</div>